import { IonImg } from "@ionic/react";

import Tooltip from "@components/Tooltip";

type Expert = {
  fullName: string;
  photoUrl: string | null;
};

export type AvatarProps = {
  className?: string;
  expert: Expert;
  size?: number;
};

const ExpertAvatar = ({ className, expert, size }: AvatarProps) => (
  <Tooltip content={expert.fullName}>
    {tooltipTriggerProps => (
      <IonImg
        alt={expert.photoUrl ? expert.fullName : ""}
        className={className}
        src={expert.photoUrl ?? undefined}
        style={{ width: size }}
        tabIndex={0}
        title={expert.photoUrl ? expert.fullName : ""}
        {...tooltipTriggerProps}
      />
    )}
  </Tooltip>
);

export default ExpertAvatar;
